function normalizeComparable(value: string | null | undefined): string {
  return (value ?? "").trim().toLocaleLowerCase();
}

export function isSystemPlaceholderTopic(topic: string): boolean {
  const normalized = normalizeComparable(topic);
  return (
    normalized.startsWith("daily learning text") ||
    normalized.startsWith("practice text for tricky words")
  );
}

export function resolvePendingGeneratedTextTitle(arg: {
  status?: string;
  topic?: string | null;
  cachedPromptTopic?: string | null;
}): string | null {
  if (arg.status === "COMPLETE") {
    return null;
  }

  const topic = (arg.topic ?? "").trim();
  if (!topic) {
    return null;
  }

  const cachedPromptTopic = (arg.cachedPromptTopic ?? "").trim();
  if (cachedPromptTopic) {
    return normalizeComparable(topic) === normalizeComparable(cachedPromptTopic)
      ? null
      : topic;
  }

  return isSystemPlaceholderTopic(topic) ? null : topic;
}
